import { BankFilled, CreditCardOutlined } from "@ant-design/icons";
import X_ACH_IMG from "../../assets/imgs/X_ACH.svg"
import RAPID_IMG from "../../assets/imgs/RAPID.svg";
import ZIP_IMG from "../../assets/imgs/ZIP.svg";
import ACH_IMG from "../../assets/imgs/Standard_ACH.svg"


export const MethodIcon = (type) => {
   switch (type) {
     case 'BANK':
        return <BankFilled style={{ fontSize: '20px', color: '#448aff' }} />;
     case 'CARD':
        return <CreditCardOutlined style={{ fontSize: '20px', color: '#448aff' }} />;
     default:
        return <BankFilled style={{ fontSize: '20px', color: '#448aff' }} />;
   }
};

export const segmentOptions = [
   { icon: ACH_IMG, label: 'Standard ACH', key: 'ACH_LEGACY' },
   { icon: X_ACH_IMG, label: 'X ACH', key: 'X_ACH' },
   { icon: RAPID_IMG, label: 'RAPID ACH', key: 'RAPID_ACH' },
   { icon: ZIP_IMG, label: 'ZIP ACH', key: 'ZIP_ACH' },
];

export const checkPaymentTypeExist = (supportedPaymentTypes = []) => {
  const ACH_TYPES = ['ZIP_ACH', 'RAPID_ACH', 'X_ACH', 'ACH_LEGACY'];

  const bankExist = supportedPaymentTypes.some(type => ACH_TYPES.includes(type));
  const cardExist = supportedPaymentTypes.includes('CARD');

  return {
    bankExist,
    cardExist
  };
};
